var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.ready
        ? _c("div", [
            _vm.loadExtraNodes
              ? _c(
                  "div",
                  { staticClass: "alert alert-info", attrs: { role: "alert" } },
                  [_vm._v("Loading extra nodes")]
                )
              : _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
            _vm._v(" Please wait, the graph is loading.\n    "),
          ])
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "data-lineage-toolbar" },
                [
                  _c("toolbar", {
                    attrs: {
                      isExpanded: _vm.isExpanded,
                      status: _vm.lineageStatus,
                    },
                    on: {
                      zoom: _vm.zoom,
                      resize: _vm.resize,
                      click: _vm.manageLink,
                      reload: _vm.reload,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("cytoscape", {
                key: _vm.reRenderKey,
                ref: "cy",
                attrs: {
                  id: "cy",
                  config: _vm.config,
                  preConfig: _vm.preConfig,
                  afterCreated: _vm.afterCreated,
                },
                on: {
                  click: _vm.click,
                  mousedown: function ($event) {
                    return _vm.highlightEdge($event, true)
                  },
                  mouseup: function ($event) {
                    return _vm.highlightEdge($event, false)
                  },
                  drag: _vm.drag,
                },
              }),
              _vm._v(" "),
              _c("tippy", {
                attrs: {
                  clickedNode: _vm.clickedNode,
                  clickedPathInfo: _vm.clickedPathInfo,
                  requestedData: _vm.requestedData,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.error
        ? _c("alert", { attrs: { type: "danger" } }, [
            _vm._v(
              "\n        There was an error with the graph. Please try again later.\n    "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }